import { render, staticRenderFns } from "./OffersDetailPopin.vue?vue&type=template&id=3489e395&scoped=true&"
import script from "./OffersDetailPopin.vue?vue&type=script&lang=js&"
export * from "./OffersDetailPopin.vue?vue&type=script&lang=js&"
import style0 from "./OffersDetailPopin.vue?vue&type=style&index=0&id=3489e395&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3489e395",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3489e395')) {
      api.createRecord('3489e395', component.options)
    } else {
      api.reload('3489e395', component.options)
    }
    module.hot.accept("./OffersDetailPopin.vue?vue&type=template&id=3489e395&scoped=true&", function () {
      api.rerender('3489e395', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/acquisition/vitrine/fragments/OffersDetailPopin.vue"
export default component.exports